// List of countries with their ISO codes for geocoding restrictions
export interface Country {
  code: string; // ISO 3166-1 alpha-2 country code
  name: string;
  nameEn: string;
  flag: string;
}

export const COUNTRIES: Country[] = [
  // North America
  { code: 'MX', name: 'México', nameEn: 'Mexico', flag: '🇲🇽' },
  { code: 'US', name: 'Estados Unidos', nameEn: 'United States', flag: '🇺🇸' },
  { code: 'CA', name: 'Canadá', nameEn: 'Canada', flag: '🇨🇦' },
  
  // Central America
  { code: 'GT', name: 'Guatemala', nameEn: 'Guatemala', flag: '🇬🇹' },
  { code: 'BZ', name: 'Belice', nameEn: 'Belize', flag: '🇧🇿' },
  { code: 'SV', name: 'El Salvador', nameEn: 'El Salvador', flag: '🇸🇻' },
  { code: 'HN', name: 'Honduras', nameEn: 'Honduras', flag: '🇭🇳' },
  { code: 'NI', name: 'Nicaragua', nameEn: 'Nicaragua', flag: '🇳🇮' },
  { code: 'CR', name: 'Costa Rica', nameEn: 'Costa Rica', flag: '🇨🇷' },
  { code: 'PA', name: 'Panamá', nameEn: 'Panama', flag: '🇵🇦' },
  
  // South America
  { code: 'CO', name: 'Colombia', nameEn: 'Colombia', flag: '🇨🇴' },
  { code: 'VE', name: 'Venezuela', nameEn: 'Venezuela', flag: '🇻🇪' },
  { code: 'GY', name: 'Guyana', nameEn: 'Guyana', flag: '🇬🇾' },
  { code: 'SR', name: 'Surinam', nameEn: 'Suriname', flag: '🇸🇷' },
  { code: 'BR', name: 'Brasil', nameEn: 'Brazil', flag: '🇧🇷' },
  { code: 'EC', name: 'Ecuador', nameEn: 'Ecuador', flag: '🇪🇨' },
  { code: 'PE', name: 'Perú', nameEn: 'Peru', flag: '🇵🇪' },
  { code: 'BO', name: 'Bolivia', nameEn: 'Bolivia', flag: '🇧🇴' },
  { code: 'PY', name: 'Paraguay', nameEn: 'Paraguay', flag: '🇵🇾' },
  { code: 'UY', name: 'Uruguay', nameEn: 'Uruguay', flag: '🇺🇾' },
  { code: 'AR', name: 'Argentina', nameEn: 'Argentina', flag: '🇦🇷' },
  { code: 'CL', name: 'Chile', nameEn: 'Chile', flag: '🇨🇱' },
  
  // Europe
  { code: 'ES', name: 'España', nameEn: 'Spain', flag: '🇪🇸' },
  { code: 'PT', name: 'Portugal', nameEn: 'Portugal', flag: '🇵🇹' },
  { code: 'FR', name: 'Francia', nameEn: 'France', flag: '🇫🇷' },
  { code: 'IT', name: 'Italia', nameEn: 'Italy', flag: '🇮🇹' },
  { code: 'DE', name: 'Alemania', nameEn: 'Germany', flag: '🇩🇪' },
  { code: 'GB', name: 'Reino Unido', nameEn: 'United Kingdom', flag: '🇬🇧' },
  { code: 'NL', name: 'Países Bajos', nameEn: 'Netherlands', flag: '🇳🇱' },
  { code: 'BE', name: 'Bélgica', nameEn: 'Belgium', flag: '🇧🇪' },
  { code: 'CH', name: 'Suiza', nameEn: 'Switzerland', flag: '🇨🇭' },
  { code: 'AT', name: 'Austria', nameEn: 'Austria', flag: '🇦🇹' },
  { code: 'SE', name: 'Suecia', nameEn: 'Sweden', flag: '🇸🇪' },
  { code: 'NO', name: 'Noruega', nameEn: 'Norway', flag: '🇳🇴' },
  { code: 'DK', name: 'Dinamarca', nameEn: 'Denmark', flag: '🇩🇰' },
  { code: 'FI', name: 'Finlandia', nameEn: 'Finland', flag: '🇫🇮' },
  { code: 'PL', name: 'Polonia', nameEn: 'Poland', flag: '🇵🇱' },
  { code: 'CZ', name: 'República Checa', nameEn: 'Czech Republic', flag: '🇨🇿' },
  { code: 'GR', name: 'Grecia', nameEn: 'Greece', flag: '🇬🇷' },
  { code: 'HU', name: 'Hungría', nameEn: 'Hungary', flag: '🇭🇺' },
  { code: 'IE', name: 'Irlanda', nameEn: 'Ireland', flag: '🇮🇪' },
  { code: 'RO', name: 'Rumania', nameEn: 'Romania', flag: '🇷🇴' },
  
  // Asia
  { code: 'CN', name: 'China', nameEn: 'China', flag: '🇨🇳' },
  { code: 'JP', name: 'Japón', nameEn: 'Japan', flag: '🇯🇵' },
  { code: 'KR', name: 'Corea del Sur', nameEn: 'South Korea', flag: '🇰🇷' },
  { code: 'IN', name: 'India', nameEn: 'India', flag: '🇮🇳' },
  { code: 'TH', name: 'Tailandia', nameEn: 'Thailand', flag: '🇹🇭' },
  { code: 'VN', name: 'Vietnam', nameEn: 'Vietnam', flag: '🇻🇳' },
  { code: 'MY', name: 'Malasia', nameEn: 'Malaysia', flag: '🇲🇾' },
  { code: 'SG', name: 'Singapur', nameEn: 'Singapore', flag: '🇸🇬' },
  { code: 'ID', name: 'Indonesia', nameEn: 'Indonesia', flag: '🇮🇩' },
  { code: 'PH', name: 'Filipinas', nameEn: 'Philippines', flag: '🇵🇭' },
  { code: 'TW', name: 'Taiwán', nameEn: 'Taiwan', flag: '🇹🇼' },
  { code: 'HK', name: 'Hong Kong', nameEn: 'Hong Kong', flag: '🇭🇰' },
  
  // Middle East
  { code: 'AE', name: 'Emiratos Árabes Unidos', nameEn: 'United Arab Emirates', flag: '🇦🇪' },
  { code: 'SA', name: 'Arabia Saudita', nameEn: 'Saudi Arabia', flag: '🇸🇦' },
  { code: 'IL', name: 'Israel', nameEn: 'Israel', flag: '🇮🇱' },
  { code: 'TR', name: 'Turquía', nameEn: 'Turkey', flag: '🇹🇷' },
  
  // Africa
  { code: 'ZA', name: 'Sudáfrica', nameEn: 'South Africa', flag: '🇿🇦' },
  { code: 'EG', name: 'Egipto', nameEn: 'Egypt', flag: '🇪🇬' },
  { code: 'MA', name: 'Marruecos', nameEn: 'Morocco', flag: '🇲🇦' },
  { code: 'NG', name: 'Nigeria', nameEn: 'Nigeria', flag: '🇳🇬' },
  { code: 'KE', name: 'Kenia', nameEn: 'Kenya', flag: '🇰🇪' },
  { code: 'GH', name: 'Ghana', nameEn: 'Ghana', flag: '🇬🇭' },
  
  // Oceania
  { code: 'AU', name: 'Australia', nameEn: 'Australia', flag: '🇦🇺' },
  { code: 'NZ', name: 'Nueva Zelanda', nameEn: 'New Zealand', flag: '🇳🇿' },
  
  // Russia
  { code: 'RU', name: 'Rusia', nameEn: 'Russia', flag: '🇷🇺' }
];

// Get country by code
export const getCountryByCode = (code: string): Country | undefined => {
  return COUNTRIES.find(country => country.code === code);
};

// Get country name in current language
export const getCountryName = (country: Country, language: string): string => {
  return language === 'en' ? country.nameEn : country.name;
};